
        (function() {
          const blockId = 'block-price_zNgXNT';
          const container = document.getElementById(blockId);
          if (!container) return;

          const multiplyByQuantity = container.dataset.multiplyByQuantity !== 'false';
          const applySubscriptionDiscount = container.dataset.applySubscriptionDiscount !== 'false';
          const saveBadgeType = container.dataset.saveBadgeType || 'percentage';
          const variants = [{"id":67579723317557,"title":"White","option1":"White","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501511220,"product_id":8936815165492,"position":9,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg","variant_ids":[67579723317557]},"available":true,"name":"V101 1500W Peak Electric Bike - White","public_title":"White","options":["White"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097022004,"position":9,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723350325,"title":"Black","option1":"Black","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501478452,"product_id":8936815165492,"position":10,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg","variant_ids":[67579723350325]},"available":true,"name":"V101 1500W Peak Electric Bike - Black","public_title":"Black","options":["Black"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160096989236,"position":10,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723383093,"title":"Grey","option1":"Grey","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501609524,"product_id":8936815165492,"position":11,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:15-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg","variant_ids":[67579723383093]},"available":true,"name":"V101 1500W Peak Electric Bike - Grey","public_title":"Grey","options":["Grey"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097120308,"position":11,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723415861,"title":"Orange","option1":"Orange","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501576756,"product_id":8936815165492,"position":12,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg","variant_ids":[67579723415861]},"available":true,"name":"V101 1500W Peak Electric Bike - Orange","public_title":"Orange","options":["Orange"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097087540,"position":12,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723448629,"title":"Green","option1":"Green","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501543988,"product_id":8936815165492,"position":13,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg","variant_ids":[67579723448629]},"available":true,"name":"V101 1500W Peak Electric Bike - Green","public_title":"Green","options":["Green"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097054772,"position":13,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}}];

          function getForm() {
            return (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) || document.querySelector('.shop-add-to-cart-wrapper form[action*="/cart/add"]');
          }

          function getQuantity() {
            const form = getForm();
            if (!form) return 1;
            const input = form.querySelector('input[name="quantity"]');
            const qty = input ? parseInt(input.value, 10) : 1;
            return isNaN(qty) || qty < 1 ? 1 : qty;
          }

          function getVariantFromForm() {
            const id = (typeof Elixir_GetProductFormVariantId === 'function' && Elixir_GetProductFormVariantId()) || null;
            if (!id) return variants.length ? variants[0] : null;
            return variants.find(function(v) { return v.id.toString() === String(id); }) || null;
          }

          function updatePriceDisplay(variant) {
            if (!variant) return;
            if (typeof window.Elixir_GetDisplayPrice !== 'function' || typeof window.Elixir_FormatMoney !== 'function') {
              runUpdate();
              return;
            }
            const qty = getQuantity();
            const compareAt = variant.compare_at_price != null ? variant.compare_at_price : (variant.compareAtPrice != null ? variant.compareAtPrice : 0);
            const result = window.Elixir_GetDisplayPrice({
              price: variant.price,
              quantity: qty,
              multiplyByQuantity: multiplyByQuantity,
              compareAtPrice: compareAt,
              applySubscriptionDiscount: applySubscriptionDiscount
            });
            const priceTotal = result.price;
            const compareTotal = result.compareAtPrice;
            const isOnSale = compareTotal > 0 && compareTotal > priceTotal;

            const priceEl = container.querySelector('.shop-product-price-block');
            const comparePriceEl = container.querySelector('.shop-compare-price');
            const saveBadge = container.querySelector('.shop-save-price');
            const percentageEl = container.querySelector('[data-save-percentage]');
            const dollarEl = container.querySelector('[data-save-dollar]');

            if (priceEl) priceEl.textContent = window.Elixir_FormatMoney(priceTotal);
            if (priceEl) priceEl.classList.toggle('on-sale', isOnSale);

            if (comparePriceEl) {
              if (isOnSale) {
                comparePriceEl.textContent = window.Elixir_FormatMoney(compareTotal);
                comparePriceEl.style.display = '';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }

            if (saveBadge) {
              if (isOnSale) {
                saveBadge.style.display = '';
                if (saveBadgeType === 'percentage' && percentageEl) {
                  const discount = Math.round(((compareTotal - priceTotal) / compareTotal) * 100);
                  percentageEl.textContent = discount;
                } else if (saveBadgeType === 'dollar_amount' && dollarEl) {
                  dollarEl.textContent = window.Elixir_FormatMoney(compareTotal - priceTotal);
                }
              } else {
                saveBadge.style.display = 'none';
              }
            }
          }

          function runUpdate(alreadyDeferredFromReady) {
            if (typeof window.Elixir_GetDisplayPrice !== 'function' || typeof window.Elixir_FormatMoney !== 'function') {
              if (alreadyDeferredFromReady) return;
              if (window.__elixirPricingReady) { setTimeout(function() { runUpdate(true); }, 0); return; }
              document.addEventListener('elixir-pricing-ready', function once() {
                document.removeEventListener('elixir-pricing-ready', once);
                runUpdate();
              }, { once: true });
              return;
            }
            const variant = getVariantFromForm();
            updatePriceDisplay(variant);
          }

          document.addEventListener('simple-variant-picker:variantChange', function(event) {
            var v = event.detail && event.detail.variant;
            if (v && typeof window.Elixir_SetProductFormVariantId === 'function') {
              window.Elixir_SetProductFormVariantId(v.id);
            }
            if (v) {
              updatePriceDisplay(v);
            } else {
              runUpdate();
            }
          });

          document.addEventListener('quantity:changed', runUpdate);

          document.addEventListener('quantity_break:changed', runUpdate);

          document.addEventListener('subscriptionContext:updated', runUpdate);

          document.addEventListener('DOMContentLoaded', function() {
            runUpdate();
          });

          if (document.readyState === 'complete' || document.readyState === 'interactive') {
            setTimeout(runUpdate, 0);
          }
        })();
      
;

      function variantPicker() {
          const productForm = document.getElementById('product-form-template--21474119974964__shop_product_details_JbqzwH');
          var variantIdInput = null;
          if (productForm) {
            variantIdInput = productForm.querySelector('input[name="id"]') ?? productForm.querySelector('input[name="product-id"]');
          }
  
          const variantData = JSON.parse(document.querySelector('.simple-variant-picker__variants-json').textContent);
          const radioInputs = document.querySelectorAll('.simple-variant-picker__radio');
          const simpleVariantPickerRoot = document.querySelector('.simple-variant-picker');
          const showVariantImages = simpleVariantPickerRoot?.dataset.showVariantImages === 'true';
          const atcButton = document.querySelector('.product-form__submit') || 
                                        document.querySelector('.shop-add-to-cart-button')
          const errorSpan = document.querySelector('.simple-variant-picker__error')
          const quantityBundleContainer = document.querySelector('.quantity-bundle-selector')
          const quantityBundleCustomPrice = quantityBundleContainer?.dataset.customPrice === 'true'
          
          
          // Clear variant ID when first_variant_auto_selected is disabled
          if (!false) variantIdInput.value = "";
             
  
          atcButton.addEventListener('click', (event) => {
            if (!variantIdInput.value) {
            event.preventDefault();
              errorSpan.style.display = 'block'
              errorSpan.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              errorSpan.style.display = "none"
            }
          })
          // Map option positions to their custom labels (if defined)
          const customLabels = {
            
              'color': "Color",
              'colour': "Color",
            
            
              'size': "Size",
            
            
            
            
          };
          
          // Map for size abbreviations
          const sizeAbbreviations = {
            'small': 'S',
            'small size': 'S',
            'medium': 'M',
            'medium size': 'M',
            'large': 'L',
            'large size': 'L',
            'extra large': 'XL',
            'extra-large': 'XL',
            'xlarge': 'XL',
            'x-large': 'XL',
            'xl': 'XL',
            'x large': 'XL',
            'extra large size': 'XL',
            'extra extra large': '2XL',
            'extra-extra-large': '2XL',
            'xxlarge': '2XL',
            'xx-large': '2XL',
            'xxl': '2XL',
            'xx large': '2XL',
            '2xl': '2XL',
            '2x large': '2XL',
            'extra extra large size': '2XL',
            'extra extra extra large': '3XL',
            'extra-extra-extra-large': '3XL',
            'xxxlarge': '3XL',
            'xxx-large': '3XL',
            'xxxl': '3XL',
            'xxx large': '3XL',
            '3xl': '3XL',
            '3x large': '3XL',
            'extra extra extra large size': '3XL',
            'extra small': 'XS',
            'extra-small': 'XS',
            'xsmall': 'XS',
            'x-small': 'XS',
            'xs': 'XS',
            'x small': 'XS',
            'extra small size': 'XS',
            'petite': 'P',
            'one size': 'OS',
            'one size fits all': 'OS',
            'one-size': 'OS',
            'one-size-fits-all': 'OS'
          };
          
          if (!productForm || !variantIdInput) return;
          
          // Function to get abbreviated size if applicable
          function getAbbreviatedSize(value, optionName) {
            if (optionName && optionName.toLowerCase().includes('size')) {
              const lowerValue = value.toLowerCase();
              return sizeAbbreviations[lowerValue] || value;
            }
            return value;
          }
  
          function formatPrice(originPrice, newPriceValue) {
              const cents = typeof newPriceValue === 'number' ? newPriceValue : parseFloat(newPriceValue);

              if (Number.isNaN(cents)) {
                  return '';
              }

              if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
                  const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
                  const formatString =
                      Shopify.money_format ||
                      Shopify.money_with_currency_format ||
                      window.Shopify?.currency?.active_format ||
                      '';
                  return Shopify.formatMoney(Math.round(cents * rate), formatString);
              }

              let priceValue = (cents / 100).toFixed(2).toString();
              if (originPrice?.includes(',')) priceValue = priceValue.replace('.', ',');
              const originPriceNumber = originPrice?.replace(/[^0-9.,]/g, '') || '';

              if (!originPrice || !originPriceNumber) {
                  return priceValue;
              }

              return originPrice.replace(originPriceNumber.toString(), priceValue);
          }

          function getQuantity() {
            if (!productForm) return 1;
            const input = productForm.querySelector('input[name="quantity"]');
            const qty = input ? parseInt(input.value, 10) : 1;
            return isNaN(qty) || qty < 1 ? 1 : qty;
          }

          /**
           * Refresh variant list/grid prices: each row shows the variant for that option value (given current other selections).
           * Uses Elixir_GetDisplayPrice; respects block settings multiply_price_by_quantity and apply_selected_subscription_discount.
           */
          function refreshVariantPickerPrices() {
            if (typeof Elixir_GetDisplayPrice !== 'function') return;
            const pickerRoot = document.querySelector('.simple-variant-picker');
            const multiplyByQuantity = pickerRoot && pickerRoot.dataset.multiplyByQuantity !== 'false';
            const applySubscriptionDiscount = pickerRoot && pickerRoot.dataset.applySubscriptionDiscount !== 'false';
            const priceContainers = document.querySelectorAll('.simple-variant-picker__quantity-break-price');
            const baseSelections = getSelectedOptions();
            const qty = getQuantity();

            priceContainers.forEach(function(container) {
              const valueContainer = container.closest('.simple-variant-picker__value-container');
              const radio = valueContainer ? valueContainer.querySelector('.simple-variant-picker__radio') : null;
              const optionPosition = radio ? radio.dataset.optionPosition : null;
              const optionValue = radio ? radio.value : null;

              let priceCents = parseInt(container.getAttribute('data-price'), 10);
              let compareAtCents = parseInt(container.getAttribute('data-compare-at-price'), 10) || 0;
              let variantId = container.getAttribute('data-variant-id') || null;

              if (optionPosition && optionValue && variantData && variantData.length) {
                const selections = Object.assign({}, baseSelections);
                selections['option' + optionPosition] = optionValue;
                const matchedVariant = variantData.find(function(v) {
                  return Object.keys(selections).every(function(k) { return v[k] === selections[k]; });
                });
                if (matchedVariant) {
                  priceCents = matchedVariant.price;
                  compareAtCents = matchedVariant.compare_at_price != null ? matchedVariant.compare_at_price : 0;
                  if (!variantId) variantId = matchedVariant.id;
                }
              }

              const result = Elixir_GetDisplayPrice({
                variantId: variantId,
                price: priceCents,
                compareAtPrice: compareAtCents,
                quantity: qty,
                multiplyByQuantity: multiplyByQuantity,
                applySubscriptionDiscount: applySubscriptionDiscount
              });

              const currentEl = container.querySelector('.simple-variant-picker__list-current-price, .variant-price');
              const compareEl = container.querySelector('.simple-variant-picker__list-compare-price, .variant-compare-price');
              const formatFn = typeof Elixir_FormatMoney === 'function' ? function(c) { return Elixir_FormatMoney(c); } : function(c) { return formatPrice(null, c); };

              if (currentEl) currentEl.textContent = formatFn(result.price);
              if (compareEl) {
                if (result.compareAtPrice > result.price && result.compareAtPrice > 0) {
                  compareEl.textContent = formatFn(result.compareAtPrice);
                  compareEl.style.display = '';
                } else {
                  compareEl.style.display = 'none';
                }
              }

              var savingsEl = container.closest('.simple-variant-picker__list-item') ? container.closest('.simple-variant-picker__list-item').querySelector('.simple-variant-picker__list-savings') : null;
              if (!savingsEl) savingsEl = container.closest('.simple-variant-picker__grid-text') ? container.closest('.simple-variant-picker__grid-text').querySelector('.horizontal-savings-text') : null;
              if (savingsEl) {
                var savingsCents = Math.max(0, result.compareAtPrice - result.price);
                if (savingsCents <= 0 || result.compareAtPrice <= 0) {
                  savingsEl.style.display = 'none';
                } else {
                  savingsEl.style.display = '';
                  var pct = result.compareAtPrice > 0 ? Math.round(savingsCents * 100 / result.compareAtPrice) : 0;
                  savingsEl.textContent = 'Save ' + pct + '% (' + formatFn(savingsCents) + ')';
                }
              }
            });
          }

          document.addEventListener('simple-variant-picker:variantChange', refreshVariantPickerPrices);
          document.addEventListener('quantity:changed', refreshVariantPickerPrices);
          document.addEventListener('quantity_break:changed', refreshVariantPickerPrices);
          document.addEventListener('subscriptionContext:updated', refreshVariantPickerPrices);
          setTimeout(refreshVariantPickerPrices, 100);

          function notifyVariantChange(variant) {
              if (!variant) return;
              document.dispatchEvent(
                  new CustomEvent('simple-variant-picker:variantChange', {
                      detail: {
                          variant,
                          source: 'simple-variant-picker',
                      },
                  }),
              );
          }        
          function updateProductImage(matchedVariant) {
              if (!matchedVariant?.featured_image) return;

              const toggledProductGallery = document.querySelector(".shop-thumbnails.toggle-product-variants");
              if (toggledProductGallery) {
                  const oldVariantMedia = toggledProductGallery.querySelector(".current-variant-media");
                  const newVariantMedia = toggledProductGallery.querySelector(`.shop-thumbnail[data-media-id='${matchedVariant.featured_media?.id}']`);

                  if (oldVariantMedia) {
                      oldVariantMedia.classList.add("visually-hidden");
                      oldVariantMedia.classList.remove("current-variant-media");
                      oldVariantMedia.style.display = "";
                  }
                  if (newVariantMedia) {
                      newVariantMedia.classList.remove("visually-hidden");
                      newVariantMedia.classList.add("current-variant-media");
                      newVariantMedia.style.display = "";
                  }
              }

              updateOptionsImages(matchedVariant, [{"id":67579723317557,"title":"White","option1":"White","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501511220,"product_id":8936815165492,"position":9,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg","variant_ids":[67579723317557]},"available":true,"name":"V101 1500W Peak Electric Bike - White","public_title":"White","options":["White"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097022004,"position":9,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723350325,"title":"Black","option1":"Black","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501478452,"product_id":8936815165492,"position":10,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg","variant_ids":[67579723350325]},"available":true,"name":"V101 1500W Peak Electric Bike - Black","public_title":"Black","options":["Black"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160096989236,"position":10,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723383093,"title":"Grey","option1":"Grey","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501609524,"product_id":8936815165492,"position":11,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:15-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg","variant_ids":[67579723383093]},"available":true,"name":"V101 1500W Peak Electric Bike - Grey","public_title":"Grey","options":["Grey"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097120308,"position":11,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723415861,"title":"Orange","option1":"Orange","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501576756,"product_id":8936815165492,"position":12,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg","variant_ids":[67579723415861]},"available":true,"name":"V101 1500W Peak Electric Bike - Orange","public_title":"Orange","options":["Orange"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097087540,"position":12,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723448629,"title":"Green","option1":"Green","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501543988,"product_id":8936815165492,"position":13,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg","variant_ids":[67579723448629]},"available":true,"name":"V101 1500W Peak Electric Bike - Green","public_title":"Green","options":["Green"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097054772,"position":13,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}}]);

              document.dispatchEvent(new CustomEvent('variant:imageChanged', {
                  detail: {
                      variantId: matchedVariant.id,
                      image: matchedVariant.featured_image,
                      mediaId: matchedVariant.featured_media.id
                  }
              }));
          }
  
          // Make entire value container clickable for horizontal layouts
          const valueContainers = document.querySelectorAll('.simple-variant-picker__option[data-text-orientation="horizontal"] .simple-variant-picker__value-container');
          valueContainers.forEach(container => {
            container.addEventListener('click', function(e) {
              // Don't trigger if clicking directly on the radio or label
              if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL') return;
              
              const radio = container.querySelector('.simple-variant-picker__radio');
              if (radio && !radio.disabled) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });
          
          // Handle dropdown selects
          const selectInputs = document.querySelectorAll('.simple-variant-picker__select');
          selectInputs.forEach(select => {
            select.addEventListener('change', function() {
                          const optionPosition = select.dataset.optionPosition;
                          updateVariantIdFromSelect(parseInt(optionPosition));
                          const optionValue = select.value;
                          if (optionPosition && optionValue) {
                              document.dispatchEvent(new CustomEvent('simple-variant-picker:optionChange', {
                                  detail: {
                                      position: optionPosition,
                                      value: optionValue,
                                      type: 'select'
                                  }
                              }));
                          }
                      });
          });
          
          // Only apply image overrides when the current option is image-driven.
          function shouldApplyVariantImage(swatch) {
            if (!swatch) return false;

            if (swatch.classList.contains('simple-variant-picker__image-variant')) {
              return true;
            }

            if (!swatch.classList.contains('simple-variant-picker__color-swatch')) {
              return false;
            }

            const optionContainer = swatch.closest('.simple-variant-picker__option');
            if (!optionContainer) return false;

            return optionContainer.classList.contains('option--images');
          }

          // Apply variant images with maximum priority
          function applyVariantImage(swatch, imageUrl) {
            if (imageUrl && showVariantImages && shouldApplyVariantImage(swatch)) {
              // Set multiple CSS properties to ensure override
              swatch.style.setProperty('background-image', `url('${imageUrl}')`, 'important');
              swatch.style.setProperty('background-color', 'transparent', 'important');
              swatch.style.setProperty('background-size', 'cover', 'important');
              swatch.style.setProperty('background-position', 'center', 'important');
              swatch.style.setProperty('background-repeat', 'no-repeat', 'important');
              swatch.style.setProperty('--swatch--background', 'none', 'important');
              swatch.style.setProperty('--variant-image-url', `url('${imageUrl}')`, 'important');
              
              // Remove any conflicting attributes
              swatch.removeAttribute('data-swatch-background');
              
              // Add a class to identify this as having a variant image
              swatch.classList.add('has-variant-image');
            }
          }
          
          // Apply variant images on page load
          radioInputs.forEach(radio => {
            const imageUrl = radio.dataset.imageUrl;
            const swatch = radio.nextElementSibling;
            if (
              imageUrl
              && swatch
              && (
                swatch.classList.contains('simple-variant-picker__color-swatch')
                || swatch.classList.contains('simple-variant-picker__image-variant')
              )
            ) {
              applyVariantImage(swatch, imageUrl);
            }
          });

          function getSelectedOptions() {
              const selected = {};
              radioInputs.forEach(radio => {
                  if (radio.checked) {
                      selected[`option${radio.dataset.optionPosition}`] = radio.value;
                  }
              });
              selectInputs.forEach(select => {
                  if (select.value) {
                      selected[`option${select.dataset.optionPosition}`] = select.value;
                  }
              });
              return selected;
          }
          
      // Function to update Images & Prices
      function updateDependentVisuals() {
        
        // Get the "Parent" Option using Shopify's standard hierarchy.
        const option1Radio = document.querySelector('.simple-variant-picker__radio[data-option-position="1"]:checked');
        
        if (!option1Radio) return;
        const option1Value = option1Radio.value;

        // Get the "Child" Options
        const option2Radios = document.querySelectorAll('.simple-variant-picker__radio[data-option-position="2"]');

        // If there is no Option 2, exit immediately to prevent errors.
        if (option2Radios.length === 0) return;

        // Access variant data
        const variantDataScript = document.querySelector('.simple-variant-picker__variants-json');
        if (!variantDataScript) return;
        const variantData = JSON.parse(variantDataScript.textContent);

        option2Radios.forEach(radio => {
          const option2Value = radio.value;

          const matchedVariant = variantData.find(variant => 
            variant.option1 === option1Value && 
            variant.option2 === option2Value
          );

          if (matchedVariant) {
            const container = radio.closest('.simple-variant-picker__value-container') || 
                              radio.closest('.simple-variant-picker__list-item') ||
                              radio.closest('label');

            if (!container) return;

            // Show matched variant's specific image
            if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
              let newSrc = matchedVariant.featured_image.src;
              if (newSrc.startsWith('//')) newSrc = 'https:' + newSrc;

              const img = container.querySelector('img');
              if (img) {
                img.src = newSrc;
                if (img.srcset) img.srcset = newSrc; 
              } else {
                const swatch = container.querySelector('.simple-variant-picker__image-variant, .simple-variant-picker__color-swatch');
                if (swatch && shouldApplyVariantImage(swatch)) {
                  applyVariantImage(swatch, newSrc);
                }
              }
            }

            // Price for this option value is updated by refreshVariantPickerPrices (Elixir_GetDisplayPrice + events)
          }
        });
      }


          function updateVariantId(changedPosition) {
            
            const selectedOptions = getSelectedOptions();
            
            // Update labels and sync quantity break inputs
            radioInputs.forEach(radio => {
              if (radio.checked) {
                const optionPosition = radio.dataset.optionPosition;
                const optionName = radio.name.replace('options[', '').replace(']', '');
                
                // Update only the corresponding option label with the selected value
                const selectedVariantLabel = document.querySelector(`.simple-variant-picker__selected-value[data-option-position="${optionPosition}"], .simple-variant-picker__selected-variant[data-option-position="${optionPosition}"], .simple-variant-picker__selected-variant-label[data-option-position="${optionPosition}"]`);
                if (selectedVariantLabel) {
                  const displayValue = optionName.toLowerCase().includes('size') ? 
                    getAbbreviatedSize(radio.value, optionName) : radio.value;
                  selectedVariantLabel.textContent = displayValue;
                }
                // .quantity-break-color-swatch-input[data-option-selector="${optionPosition}"]
                // .quantity-break-variant-select[data-option-selector="${optionPosition}"],
                // .quantity-break-variant-image-input[data-option-selector="${optionPosition}"]
                const query = `.quantity-break-variant-select[data-option-selector="${optionPosition}"]`
                const quantityBreakInputs = document.querySelectorAll(query);
                
                quantityBreakInputs.forEach((_select) => {
                  
                  _select.value = radio.value;
                });       
              }
            });
            // Find matching variant
            const matchedVariant = variantData.find(variant => {
              return Object.keys(selectedOptions).every(key => 
                variant[key] === selectedOptions[key]
              );
            });
            
            if (matchedVariant) {
              // Update variant ID in the form
              variantIdInput.value = matchedVariant.id;
              if (typeof window.Elixir_SetProductFormVariantId === 'function') {
                window.Elixir_SetProductFormVariantId(matchedVariant.id);
              }
              // Update URL with variant ID
              const url = new URL(window.location.href);
              url.searchParams.set("variant", matchedVariant.id);
              window.history.replaceState({}, "", url);
              
              try {
                /**
                * * update add to cart button price
                */
                const price = matchedVariant.price;
                const comparePrice = matchedVariant.compare_at_price;
  
                console.log({ price, comparePrice });
                
                const totalPriceValue = formatPrice(originPrice, price);
                const comparePriceValue = formatPrice(originPrice, comparePrice);
                
                console.log({ totalPriceValue, comparePriceValue });
  
                const productPriceLabel = document.querySelector(".shop-product-price-block");
                const comparePriceLabel = document.querySelector(".shop-compare-price");
                // Verify if the custom price is enable
                const quantityBreakContainer = document.querySelector('.quantity-break-container')
                const quantityBreakCustomPrice = quantityBreakContainer?.getAttribute('data-custom-price')
                
  
                if (quantityBreakCustomPrice !== 'true' && !quantityBundleCustomPrice) {
                  
                if (productPriceLabel)
                  productPriceLabel.innerHTML = totalPriceValue;
                if (comparePrice > price && comparePriceLabel)
                  comparePriceLabel.innerHTML = comparePriceValue;
                else if (comparePriceLabel)
                  comparePriceLabel.innerHTML = ""
  
                const addToCartButton = document.querySelector('.product-form__submit .button__text') || 
                                        document.querySelector('.shop-add-to-cart-button .button-text') ||
                                        document.querySelector('[data-add-to-cart-text]');
                if (addToCartButton) {
                  if (matchedVariant.available && showPriceButton) {
                    let buttonText = addToCartButtonText;
                    buttonText += " - " + totalPriceValue;
                    if (comparePrice > price)
                      buttonText += ` <span class="compare-price">(${comparePriceValue})</span>`;
                    addToCartButton.innerHTML = buttonText;
                  } else if (!matchedVariant.available) {
                    addToCartButton.textContent = (typeof window.variantStrings !== 'undefined' && window.variantStrings.soldOut) ? window.variantStrings.soldOut : 'Sold out';
                  }
                }
                // * end of ACT price update handler
                }
  
              } catch (e) {
                console.error("Error while updating ATC button price", e);
              }
              // Update product image if available and setting is enabled
              updateProductImage(matchedVariant);
              
              updateAvailableOptions(selectedOptions, changedPosition);
              updateAvailableOptionsForDropdowns(selectedOptions, changedPosition);
              updateDependentVisuals();
              notifyVariantChange(matchedVariant);
            }
          }

          function updateOptionsImages(matchedVariant, allVariants) {
            if (!matchedVariant) return;

            const dynamicContainers = document.querySelectorAll('[data-dynamic-images="true"]');
            dynamicContainers.forEach((container) => {
              const targetIndex = parseInt(container.dataset.optionIndex);

              const choices = Array.from(container.querySelectorAll('.simple-variant-picker__value-container'))
                .map(el => el.querySelector('input'));

              choices.forEach((choice) => {
                const choiceValue = choice.value;

                const foundMatch = allVariants.find(v => {
                  return v.options.every((optValue, idx) => {
                    const indexUpdated = idx + 1;
                    if (indexUpdated === targetIndex) {
                      return optValue === choiceValue;
                    }
                    return optValue === matchedVariant.options[idx];
                  });
                });

                if (foundMatch && foundMatch.featured_image) {
                  const img = choice.parentElement.querySelector('img') || null;

                  if (img) {
                    const newSrc = foundMatch.featured_image.src;
                    img.src = newSrc;
                    img.srcset = newSrc;  
                  }
                }
              });
            });
          };

          function updateVariantIdFromSelect(changedPosition) {
            const selectedOptions = getSelectedOptions();
            
            // Find matching variant
            const matchedVariant = variantData.find(variant => {
              return Object.keys(selectedOptions).every(key => 
                variant[key] === selectedOptions[key]
              );
            });
            
            if (matchedVariant) {
              // Update variant ID in the form
              variantIdInput.value = matchedVariant.id;
              if (typeof window.Elixir_SetProductFormVariantId === 'function') {
                window.Elixir_SetProductFormVariantId(matchedVariant.id);
              }
              // Update URL with variant ID
              const url = new URL(window.location.href);
              url.searchParams.set("variant", matchedVariant.id);
              window.history.replaceState({}, "", url);
  
              try {
                // Update add to cart button price
                const price = matchedVariant.price;
                const comparePrice = matchedVariant.compare_at_price;
  
                const totalPriceValue = formatPrice(originPrice, price);
                const comparePriceValue = formatPrice(originPrice, comparePrice);
  
                const productPriceLabel = document.querySelector(".shop-product-price-block");
                const comparePriceLabel = document.querySelector(".shop-compare-price");
                // Verify if the custom price is enable
                const quantityBreakContainer = document.querySelector('.quantity-break-container')
                const quantityBreakCustomPrice = quantityBreakContainer?.getAttribute('data-custom-price')
  
             
  
                if (quantityBreakCustomPrice !== 'true' && !quantityBundleCustomPrice) {
                 
                  if (productPriceLabel )
                    productPriceLabel.innerHTML = totalPriceValue;
                  if (comparePrice > price && comparePriceLabel)
                    comparePriceLabel.innerHTML = comparePriceValue;
                  else if (comparePriceLabel)
                    comparePriceLabel.innerHTML = ""

                  
                  let buttonText = addToCartButtonText;
                  buttonText += " - " + totalPriceValue;
                   if (comparePrice > price)
                    buttonText += ` <span class="compare-price">(${comparePriceValue})</span>`;
                  const addToCartButton = document.querySelector('.product-form__submit .button__text') || 
                  document.querySelector('.shop-add-to-cart-button .button-text') ||
                  document.querySelector('[data-add-to-cart-text]');
                  if (addToCartButton) {
                    if (matchedVariant.available && showPriceButton) {
                      let buttonText = addToCartButtonText;
                      buttonText += " - " + totalPriceValue;
                      if (comparePrice > price)
                        buttonText += ` <span class="compare-price">(${comparePriceValue})</span>`;
                      addToCartButton.innerHTML = buttonText;
                    } else if (!matchedVariant.available) {
                      addToCartButton.textContent = (typeof window.variantStrings !== 'undefined' && window.variantStrings.soldOut) ? window.variantStrings.soldOut : 'Sold out';
                    }
                  }
                }
  
                } catch (e) {
                  console.error("Error while updating ATC button price", e);
                }
              
  
              
  
              
              // Update product image if available and setting is enabled
              updateProductImage(matchedVariant);
              
              // Update availability state across all display types (radios and dropdowns)
              updateAvailableOptions(selectedOptions, changedPosition);
              updateAvailableOptionsForDropdowns(selectedOptions, changedPosition);
              notifyVariantChange(matchedVariant);
            }
          }
          
          function updateAvailableOptionsForDropdowns(selectedOptions, changedPosition) {
            const optionPositions = [1, 2, 3];
            
            optionPositions.forEach(position => {
              const positionKey = `option${position}`;
              
              // Skip the option that was just changed
              if (changedPosition != null && position === changedPosition) return;
              
              // Get the select for this position
              const positionSelect = document.querySelector(`.simple-variant-picker__select[data-option-position="${position}"]`);
              
              if (positionSelect) {
                const options = positionSelect.querySelectorAll('option');
                let hasSelectedValid = false;
                let firstAvailableValue = null;
                
                options.forEach(option => {
                  if (option.value === '') return;

                  let exists = false;
                  let available = false;
                  for (const variant of variantData) {
                    const matchesSelected = Object.keys(selectedOptions).every(key => key === positionKey || variant[key] === selectedOptions[key]);
                    if (matchesSelected && variant[positionKey] === option.value) {
                      exists = true;
                      if (variant.available) {
                        available = true;
                        break;
                      }
                    }
                  }

                  if (!exists) {
                    option.disabled = true;
                    option.style.display = '';
                    if (option.selected) option.selected = false;
                  } else {
                    option.disabled = !available;
                    option.style.display = '';
                    if (option.selected && available) hasSelectedValid = true;
                    if (available && !firstAvailableValue) firstAvailableValue = option.value;
                  }
                });

                if (!hasSelectedValid && firstAvailableValue) {
                  positionSelect.value = firstAvailableValue;
                  positionSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          }
          
          function updateAvailableOptions(selectedOptions, changedPosition) {
            const optionPositions = [1, 2, 3];
            
            optionPositions.forEach(position => {
              const positionKey = `option${position}`;
                
              // Skip the option that was just changed
              if (changedPosition != null && position === changedPosition) return;
              
              // Get all radio buttons for this position
              const positionRadios = document.querySelectorAll(`.simple-variant-picker__radio[data-option-position="${position}"]`);
              
              let hasCheckedValid = false;
              let firstAvailableRadio = null;

              positionRadios.forEach(radio => {
                    const optionValue = radio.value;
                    const container = radio.closest('.simple-variant-picker__value-container');
                    const label = radio.nextElementSibling;

                    let exists = false;
                    let available = false;
                    for (const variant of variantData) {
                      const matchesSelected = Object.keys(selectedOptions).every(key => key === positionKey || variant[key] === selectedOptions[key]);
                      if (matchesSelected && variant[positionKey] === optionValue) {
                        exists = true;
                        if (variant.available) {
                          available = true;
                          break;
                        }
                      }
                    }

                    if (!exists || !available) {
                      radio.disabled = true;
                      if (container) container.style.display = '';
                      label.classList.remove('non-existent');
                      label.classList.add('unavailable');
                      if (!exists && radio.checked) radio.checked = false;
                    } else {
                      radio.disabled = false;
                      if (container) container.style.display = '';
                      label.classList.remove('non-existent');
                      label.classList.remove('unavailable');
                      if (radio.checked) hasCheckedValid = true;
                      if (!firstAvailableRadio) firstAvailableRadio = radio;
                    }
                });

                if (!hasCheckedValid && firstAvailableRadio) {
                  firstAvailableRadio.checked = true;
                  firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
          }
  
          // Handle radio input changes: update variant, dispatch option change event, and protect swatch styles
          radioInputs.forEach(radio => {
            radio.addEventListener('change', function(e) {
                          const optionPosition = radio.dataset.optionPosition;
                          const optionValue = radio.value;
              // Stop the event from propagating to other variant systems
            //  e.stopPropagation();
              // e.stopImmediatePropagation();
              
              updateVariantId(parseInt(optionPosition));
                          if (optionPosition && optionValue) {
                              document.dispatchEvent(new CustomEvent('simple-variant-picker:optionChange', {
                                  detail: {
                                      position: optionPosition,
                                      value: optionValue,
                                      type: 'radio'
                                  }
                              }));
                          }
              
              // Prevent default variant-selects from interfering
              setTimeout(() => {
                // Override any default swatch updates that might happen after this
                const defaultSwatches = document.querySelectorAll('.swatch');
                const simpleSwatches = document.querySelectorAll('.simple-variant-picker__color-swatch.has-variant-image, .simple-variant-picker__image-variant.has-variant-image');
                
                // Ensure our simple variant picker swatches take priority
                simpleSwatches.forEach(swatch => {
                  if (swatch.style.backgroundImage) {
                    // Force our background image to stay
                    const currentBg = swatch.style.backgroundImage;
                    swatch.style.setProperty('background-image', currentBg, 'important');
                    swatch.style.setProperty('background-color', 'transparent', 'important');
                  }
                });
              }, 10);
            });
          });
  
          // Override the default variant-selects behavior
          const variantSelects = document.querySelector('variant-selects');
          if (variantSelects) {
            // Disable the default variant-selects component
            variantSelects.style.display = 'none';
            
            // Also remove its event listeners by cloning elements
            const defaultInputs = variantSelects.querySelectorAll('input, select');
            defaultInputs.forEach(input => {
              // Clone the element to remove all event listeners
              const newInput = input.cloneNode(true);
              input.parentNode.replaceChild(newInput, input);
            });
          }
  
          // Block theme swatch inputs from interfering with our variant picker
          const swatchInputs = document.querySelectorAll('.swatch-input__input');
          swatchInputs.forEach(input => {
            input.addEventListener('change', function(e) {
              e.stopPropagation();
              e.preventDefault();
              return false;
            });
          });
  
          // Monitor for any external changes to our swatches and restore them
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const target = mutation.target;
                if (target.classList.contains('simple-variant-picker__color-swatch') || target.classList.contains('simple-variant-picker__image-variant')) {
                  // Restore variant image if it was overridden
                  const radio = target.previousElementSibling;
                  const imageUrl = radio ? radio.dataset.imageUrl : null;
                  if (imageUrl && showVariantImages && shouldApplyVariantImage(target)) {
                    // Use our function to ensure proper application
                    setTimeout(() => applyVariantImage(target, imageUrl), 0);
                  }
                }
              }
            });
          });
  
          // Observe all simple variant picker swatches and image variants
          document.querySelectorAll('.simple-variant-picker__color-swatch, .simple-variant-picker__image-variant').forEach(swatch => {
            observer.observe(swatch, { attributes: true, attributeFilter: ['style', 'class'] });
          });
  
          // Force override any theme swatch initialization
          setTimeout(() => {
            radioInputs.forEach(radio => {
              const imageUrl = radio.dataset.imageUrl;
              const swatch = radio.nextElementSibling;
              if (
                imageUrl
                && swatch
                && (
                  swatch.classList.contains('simple-variant-picker__color-swatch')
                  || swatch.classList.contains('simple-variant-picker__image-variant')
                )
              ) {
                applyVariantImage(swatch, imageUrl);
              }
            });
          }, 100);
  
          // Prevent default media gallery updates from other systems
          document.addEventListener('variant:changed', function(e) {
            e.stopPropagation();
            e.preventDefault();
          }, true);
  
          document.addEventListener('variantImageSelected', function(e) {
            e.stopPropagation(); 
            e.preventDefault();
          }, true);
  
          // Initialize variant from URL on page load
          function initializeVariantFromURL() {
            const urlParams = new URLSearchParams(window.location.search);
            const variantIdFromURL = urlParams.get('variant');
            
            if (variantIdFromURL) {
              const variantFromURL = variantData.find(variant => variant.id.toString() === variantIdFromURL);
              if (variantFromURL && variantFromURL.available) {
                // Set the variant ID in the form
                variantIdInput.value = variantFromURL.id;
                
                // Select the corresponding radio buttons
                radioInputs.forEach(radio => {
                  const optionPosition = radio.dataset.optionPosition;
                  const optionValue = variantFromURL[`option${optionPosition}`];
                  
                  if (radio.value === optionValue) {
                    radio.checked = true;
                    
                    // Update the selected variant label
                    const selectedVariantLabel = document.querySelector(`.simple-variant-picker__selected-value[data-option-position="${optionPosition}"], .simple-variant-picker__selected-variant[data-option-position="${optionPosition}"], .simple-variant-picker__selected-variant-label[data-option-position="${optionPosition}"]`);
                    if (selectedVariantLabel) {
                      const optionName = radio.name.replace('options[', '').replace(']', '');
                      const displayValue = optionName.toLowerCase().includes('size') ? 
                        getAbbreviatedSize(radio.value, optionName) : radio.value;
                      selectedVariantLabel.textContent = displayValue;
                    }
                  }
                });
                
                // Update availability state for all display types based on URL variant
                const selectedOptions = {
                  option1: variantFromURL.option1,
                  option2: variantFromURL.option2,
                  option3: variantFromURL.option3
                };
                
                updateAvailableOptions(selectedOptions, null);
                updateDependentVisuals();
                updateAvailableOptionsForDropdowns(selectedOptions, null);
              }
            }
          }
          
          // Initialize variant from URL when page loads
          initializeVariantFromURL();
          setTimeout(updateDependentVisuals, 50);
          updateOptionsImages(null, [{"id":67579723317557,"title":"White","option1":"White","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501511220,"product_id":8936815165492,"position":9,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg","variant_ids":[67579723317557]},"available":true,"name":"V101 1500W Peak Electric Bike - White","public_title":"White","options":["White"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097022004,"position":9,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723350325,"title":"Black","option1":"Black","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501478452,"product_id":8936815165492,"position":10,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg","variant_ids":[67579723350325]},"available":true,"name":"V101 1500W Peak Electric Bike - Black","public_title":"Black","options":["Black"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160096989236,"position":10,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723383093,"title":"Grey","option1":"Grey","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501609524,"product_id":8936815165492,"position":11,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:15-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg","variant_ids":[67579723383093]},"available":true,"name":"V101 1500W Peak Electric Bike - Grey","public_title":"Grey","options":["Grey"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097120308,"position":11,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723415861,"title":"Orange","option1":"Orange","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501576756,"product_id":8936815165492,"position":12,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg","variant_ids":[67579723415861]},"available":true,"name":"V101 1500W Peak Electric Bike - Orange","public_title":"Orange","options":["Orange"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097087540,"position":12,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723448629,"title":"Green","option1":"Green","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501543988,"product_id":8936815165492,"position":13,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg","variant_ids":[67579723448629]},"available":true,"name":"V101 1500W Peak Electric Bike - Green","public_title":"Green","options":["Green"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097054772,"position":13,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}}])

          // Run initial availability check on page load (per-position so each option filters against the others)
          const initialOptions = getSelectedOptions();
          if (Object.keys(initialOptions).length > 0) {
            Object.keys(initialOptions).forEach(key => {
              const pos = parseInt(key.replace('option', ''));
              updateAvailableOptions(initialOptions, pos);
              updateAvailableOptionsForDropdowns(initialOptions, pos);
            });
          } 
      }

        document.addEventListener('DOMContentLoaded', variantPicker);

        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", variantPicker);
          document.addEventListener("shopify:section:reorder", variantPicker);
        }
    
;

        // Make translations available to JS
        window.variantStrings = window.variantStrings || {};
        window.variantStrings.addToCart = "Add to cart";
        window.variantStrings.soldOut = "Sold out";
        window.variantStrings.adding = "Add to cart";
        window.variantStrings.added = "Add to cart";

        var addToCartButtonText = "Add to cart"
        var showPriceButton = false
      
;

        /* Add to cart and redirect to checkout */
        function skipToCheckout(e) {
          e.preventDefault();
          if (!Elixir_ProductFormExists()) return;
          var form = Elixir_GetProductForm();
          fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form)
          }).then(function (r) {
            if (r.ok) window.location.href = '/checkout';
          });
        }

        // Add to Cart button: when "Show price in button" is on, keep price in sync via Elixir_GetDisplayPrice and standard events
        document.addEventListener('DOMContentLoaded', function () {
          if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
          if (!showPriceButton) return;

          const mainAtcBtn = document.querySelector('.shop-add-to-cart-button');
          const btnTextEl = mainAtcBtn && mainAtcBtn.querySelector('.button-text');
          if (!mainAtcBtn || !btnTextEl) return;

          const variants = [{"id":67579723317557,"title":"White","option1":"White","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501511220,"product_id":8936815165492,"position":9,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg","variant_ids":[67579723317557]},"available":true,"name":"V101 1500W Peak Electric Bike - White","public_title":"White","options":["White"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097022004,"position":9,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-7ea0ed4aceca41b8bb044e50989c29c4.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723350325,"title":"Black","option1":"Black","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501478452,"product_id":8936815165492,"position":10,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg","variant_ids":[67579723350325]},"available":true,"name":"V101 1500W Peak Electric Bike - Black","public_title":"Black","options":["Black"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160096989236,"position":10,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-a757235cffc647cfba710febbbd930b1.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723383093,"title":"Grey","option1":"Grey","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501609524,"product_id":8936815165492,"position":11,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:15-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg","variant_ids":[67579723383093]},"available":true,"name":"V101 1500W Peak Electric Bike - Grey","public_title":"Grey","options":["Grey"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097120308,"position":11,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-bba69b45c7c04dfc86fe13c3ba9a72eb.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723415861,"title":"Orange","option1":"Orange","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501576756,"product_id":8936815165492,"position":12,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg","variant_ids":[67579723415861]},"available":true,"name":"V101 1500W Peak Electric Bike - Orange","public_title":"Orange","options":["Orange"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097087540,"position":12,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-9d4a9545df6340a39848e2ffc8d4064b.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}},{"id":67579723448629,"title":"Green","option1":"Green","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":false,"featured_image":{"id":37646501543988,"product_id":8936815165492,"position":13,"created_at":"2026-08-28T00:28:13-04:00","updated_at":"2026-08-28T00:28:14-04:00","alt":null,"width":800,"height":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg","variant_ids":[67579723448629]},"available":true,"name":"V101 1500W Peak Electric Bike - Green","public_title":"Green","options":["Green"],"price":7999,"weight":0,"compare_at_price":50000,"inventory_management":null,"barcode":null,"featured_media":{"alt":null,"id":29160097054772,"position":13,"preview_image":{"aspect_ratio":1.0,"height":800,"width":800,"src":window.__ATL_BASE+"atl-0d6e39aaf32a458dabfbf784b6f212b6.jpg"}},"requires_selling_plan":false,"selling_plan_allocations":[],"quantity_rule":{"min":1,"max":null,"increment":1}}];
          function getForm() {
            return (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) || document.querySelector('.shop-add-to-cart-wrapper form[action*="/cart/add"]');
          }
          function getQuantity() {
            const form = getForm();
            if (!form) return 1;
            const input = form.querySelector('input[name="quantity"]');
            const qty = input ? parseInt(input.value, 10) : 1;
            return isNaN(qty) || qty < 1 ? 1 : qty;
          }
          function getVariantFromForm() {
            const id = typeof Elixir_GetProductFormVariantId === 'function' ? Elixir_GetProductFormVariantId() : null;
            if (id == null) return variants.length ? variants[0] : null;
            return variants.find(function (v) { return v.id.toString() === String(id); }) || variants[0] || null;
          }
          var addToCartPriceDeferredFromReady = false;
          function updateAddToCartButtonPrice() {
            const variant = getVariantFromForm();
            if (!variant) return;
            if (typeof window.Elixir_GetDisplayPrice !== 'function' || typeof window.Elixir_FormatMoney !== 'function') {
              if (addToCartPriceDeferredFromReady) return;
              if (window.__elixirPricingReady) { addToCartPriceDeferredFromReady = true; setTimeout(updateAddToCartButtonPrice, 0); return; }
              document.addEventListener('elixir-pricing-ready', function once() {
                document.removeEventListener('elixir-pricing-ready', once);
                updateAddToCartButtonPrice();
              }, { once: true });
              return;
            }
            const qty = getQuantity();
            const compareAt = variant.compare_at_price != null ? variant.compare_at_price : (variant.compareAtPrice != null ? variant.compareAtPrice : 0);
            const result = window.Elixir_GetDisplayPrice({
              price: variant.price,
              quantity: qty,
              multiplyByQuantity: true,
              compareAtPrice: compareAt,
              applySubscriptionDiscount: true
            });
            const persistentText = mainAtcBtn.dataset.persistentText || addToCartButtonText || 'Add to cart';
            let html = persistentText + ' - ' + window.Elixir_FormatMoney(result.price);
            if (result.compareAtPrice > result.price && result.compareAtPrice > 0) {
              html += ' <span class="compare-price">(' + window.Elixir_FormatMoney(result.compareAtPrice) + ')</span>';
            }
            btnTextEl.innerHTML = html;
          }

          document.addEventListener('simple-variant-picker:variantChange', function(event) {
            var v = event.detail && event.detail.variant;
            if (v && typeof window.Elixir_SetProductFormVariantId === 'function') {
              window.Elixir_SetProductFormVariantId(v.id);
            }
            updateAddToCartButtonPrice();
          });
          document.addEventListener('quantity:changed', updateAddToCartButtonPrice);
          document.addEventListener('quantity_break:changed', updateAddToCartButtonPrice);
          document.addEventListener('subscriptionContext:updated', updateAddToCartButtonPrice);
          document.addEventListener('product-form:refresh-button-price', updateAddToCartButtonPrice);
          updateAddToCartButtonPrice();
        });



          
      
;

  document.addEventListener('DOMContentLoaded', function () {
    const dateElement = document.querySelector('.free-shipping-date[data-timestamp]'); // Target only elements needing JS formatting
    if (dateElement) {
      try {
        const timestamp = parseInt(dateElement.dataset.timestamp, 10) * 1000; // Convert Liquid seconds to JS milliseconds
        const locale = dateElement.dataset.locale || 'en'; // Default to English if locale somehow missing
        const jsDate = new Date(timestamp);

        // Define formatting options (you could make these settings too, but starting simple)
        const options = { month: 'long', day: 'numeric' };

        const formatter = new Intl.DateTimeFormat(locale, options);
        dateElement.textContent = formatter.format(jsDate);
      } catch (error) {
        console.error('Error formatting free shipping notice date:', error);
        // Optionally display a fallback or leave the placeholder
      }
    }
  });

;

	document.addEventListener("DOMContentLoaded", function () {
		const faqItems = document.querySelectorAll('.faq-item');
		const accordionMode = true;
    
		faqItems.forEach((item) => {
			const questionBtn = item.querySelector('.faq-question');
			const answer = item.querySelector('.faq-answer');
			if (questionBtn && answer) {
				questionBtn.addEventListener('click', function () {
					const isOpen = item.classList.contains('active');
					if (accordionMode) {
						faqItems.forEach((other) => {
							if (other !== item) {
								other.classList.remove('active');
								const otherBtn = other.querySelector('.faq-question');
								const otherAnswer = other.querySelector('.faq-answer');
								if (otherBtn) {
									otherBtn.setAttribute('aria-expanded', 'false');
								}
								if (otherAnswer) {
									otherAnswer.setAttribute('aria-hidden', 'true');
									otherAnswer.style.maxHeight = null;
								}
							}
						});
					}
					if (!isOpen) {
						item.classList.add('active');
						questionBtn.setAttribute('aria-expanded', 'true');
						answer.setAttribute('aria-hidden', 'false');
						const answerInner = answer.querySelector('.faq-answer-inner');
						if (answerInner) {
							answer.style.maxHeight = (answerInner.scrollHeight + 16) + "px";
						}
					} else {
						item.classList.remove('active');
						questionBtn.setAttribute('aria-expanded', 'false');
						answer.setAttribute('aria-hidden', 'true');
						answer.style.maxHeight = null;
					}
				});
			}
		});
		// On load, set maxHeight for open items (if any)
		faqItems.forEach((item) => {
			if (item.classList.contains('active')) {
				const answer = item.querySelector('.faq-answer');
				const answerInner = answer ? answer.querySelector('.faq-answer-inner') : null;
				if (answer && answerInner) {
					answer.style.maxHeight = (answerInner.scrollHeight + 16) + "px";
				}
			}
		});
	});

;

  var parser = new DOMParser();
  var originPrice = '$79.99';
  const currency = window.Shopify?.currency?.active ?? 'USD';

  const formId = 'product-form-template--21474119974964__shop_product_details_JbqzwH';
  const form = document.getElementById(formId);

  function formatMoney(newMoney) {
    const originPriceNumber = originPrice.replace(/[^0-9.,]/g, '');
    return `${originPrice.replace(originPriceNumber, newMoney)} ${currency}`;
  }
  function formatMoneyWithoutSuffix(newMoney) {
    const originPriceNumber = originPrice.replace(/[^0-9.,]/g, '');
    return `${originPrice.replace(originPriceNumber, newMoney)}`;
  }

  if (window.innerWidth <= 767 && document.querySelector('.shop-mobile-arrows')) {
    const prevBtn = document.querySelector('.shop-mobile-arrow-prev');
    const nextBtn = document.querySelector('.shop-mobile-arrow-next');

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        // Logique pour image précédente
        navigateToImage('prev');
      });

      nextBtn.addEventListener('click', () => {
        // Logique pour image suivante
        navigateToImage('next');
      });
    }
  }

  const quantityElems = form.querySelectorAll('input[type="hidden"][name="quantity"]');
  const addQuantityElem = (quantityVal) => {
    const curForm = document.getElementById(formId);
    const quantityElem = document.createElement('input');
    quantityElem.setAttribute('type', 'hidden');
    quantityElem.setAttribute('name', 'quantity');
    quantityElem.setAttribute('value', quantityVal);
    curForm.appendChild(quantityElem);
  };
